import { CheckCircle } from "@material-ui/icons";
import * as React from "react";
import { BooleanField, Create, SimpleForm, TextInput, required, useNotify, useRefresh } from "react-admin";

const PbhResponseTimeException = props => {
  const refresh = useRefresh();
  const notify = useNotify();

  const { record } = props;

  const initialValues = {
    requestId: record?.id,
    isException: true,
  };

  const onSuccess = () => {
    notify("Element saved!");
    refresh();
  };

  return (
    <Create {...props} onSuccess={onSuccess} resource="pbhrequestresponsetimeexceptions" record={initialValues}>
      <SimpleForm>
        <BooleanField source="isException" TrueIcon={CheckCircle} />
        <TextInput source="exceptionNote" validate={required()} multiline minRows={2} />
      </SimpleForm>
    </Create>
  );
};
export default PbhResponseTimeException;
